export default "__VITE_ASSET__B8tgHrDL__"